import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
    delay: 5000,
    disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	navigation: {
    nextEl: ".banner .swiper-button-next",
    prevEl: ".banner .swiper-button-prev",
  },
}); 

var aboutSwiper = new Swiper('.section2 .swiper', {
	autoplay: {
    delay: 4000,
    disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
}); 

$(".section7 ul li").hover(function() {
	$(".section7 ul li").removeClass("active1");
	$(".section7 ul li").removeClass("active2");
	$(this).addClass('active1').siblings().addClass("active2");
})